.modalHeader {
  flex-wrap: wrap;

  .lineBreak {
    flex-basis: 100%;
    height: 0;
  }
}
